import { ExternalApplicationRequest } from '@servicetitan/financing-api-client';

export const prepareExternalApplicationData = (applicationData: ExternalApplicationRequest) => {
    const finalApplicationData = { ...applicationData };

    finalApplicationData.applicant!.phone = finalApplicationData.applicant!.phone?.replace(
        /[\(\)\s-]/g,
        '',
    );
    finalApplicationData.applicant!.firstName = finalApplicationData.applicant!.firstName?.trim();
    finalApplicationData.applicant!.lastName = finalApplicationData.applicant!.lastName?.trim();

    return finalApplicationData;
};
